// 永続化するキーのリスト
// common
export const DISPLAY_NAME = 'displayName';
export const SHOULD_SHOW_CONFIRM = 'shouldShowConfirm';
export const SHOULD_SHOW_COPY = 'shouldShowCopy';
export const SHOULD_SHOW_SIDE_PANEL = 'shouldShowSidePanel';
export const TOAST = 'toast';

// otonami
export const SEARCHED_EXPERIENCES = 'searchedExperiences';
export const IS_VISIBLE_ALL_TEXT = 'isVisibleAllText';
export const RESERVATION_QUERY_OBJ = 'reservationsQueryObj';
export const RESERVATION_CALENDAR_QUERY_OBJ = 'reservationCalendarQueryObj';
export const EXPERIENCE_REVIEW_QUERY_OBJ = 'experienceReviewsQueryObj';
export const CREATIVE_VIEWED_EXPERIENCES = 'creativeViewedExperiences';

// wabunka
export const WABUNKA_SEARCHED_EXPERIENCE_IDS = 'wabunkaSearchedExperienceIds';

export const PERSIST_KEY_LIST = [SEARCHED_EXPERIENCES, WABUNKA_SEARCHED_EXPERIENCE_IDS, CREATIVE_VIEWED_EXPERIENCES] as const;

export type PERSIST_KEY = (typeof PERSIST_KEY_LIST)[number];

export const stateFactory = {
  /**
   * Cypress でモックが可能なようにオブジェクト形式にしている
   * 与えられたキーで Global State を初期化する
   * 既に同じキーで State が存在する場合は何もしない
   * @param key state のキーです
   * @param defaultValue state の初期値です
   */
  create: <T>(key: string, defaultValue: T) => {
    const state = useState<T>(key);

    // 既に State が作成されている場合は上書きしない
    if (state.value) return state;

    // State 未作成の場合は新しい State を作成して返却する
    return useState<T>(key, () => defaultValue);
  },
  /**
   * 与えられたキーの State を localStorage で永続化する
   */
  persist: (key: string) => {
    const state = useState(key);
    localStorage.setItem(key, JSON.stringify(state.value));
  },
  /**
   * localStorage から与えられたキーの State を復元する
   */
  restore: (key: string) => {
    const state = useState(key);
    const value = localStorage.getItem(key);
    if (value) state.value = JSON.parse(value);
  },
};
